import {Component, EventEmitter, Input, OnInit, Output, OnDestroy} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Observable} from 'rxjs/Observable';

import {
    FORM_DIRECTIVES,
    FORM_PROVIDERS,
    REACTIVE_FORM_DIRECTIVES,
    FormControl,
    FormGroup,
    Validators
} from '@angular/forms';
import {AlertComponent, MODAL_DIRECTIVES, BS_VIEW_PROVIDERS} from 'ng2-bootstrap/ng2-bootstrap';
import {TYPEAHEAD_DIRECTIVES} from 'ng2-bootstrap/ng2-bootstrap';
import {RolesService} from "../../service/roles.service";
import {Rol} from "../../domain/rol";
import {ActionAllowed} from '../../domain/actionAllowed';
import {RolPermission} from "../../domain/rolPermission";
import {
    DEFAULT_ERROR_MESSAGES
} from "../../validators/validators";

@Component({
    selector: 'rol-editor',
    template: require('./rol.editor.component.html'),
    directives: [
        FORM_DIRECTIVES,
        REACTIVE_FORM_DIRECTIVES,
        AlertComponent,
        TYPEAHEAD_DIRECTIVES,
        MODAL_DIRECTIVES
    ],
    providers: [
        FORM_PROVIDERS,
        BS_VIEW_PROVIDERS
    ],
})
export class RolEditorComponent implements OnInit, OnDestroy {

    @Input() rol:Rol;
    @Output() close = new EventEmitter();

    public errorMessages:any;
    public errorMessage:string;
    public successMessage:string;

    private sub:any;
    public form:FormGroup;

    private rolId:string;

    public createMode:boolean;
    public loading:boolean;

    private permissionSelectedId:string;
    public permissionSelected:RolPermission;
    public actionsAllowed:ActionAllowed[];
    public actionsSelected:string[];

    constructor(private rolesService:RolesService,
                private route:ActivatedRoute) {
        this.init();
    }

    private init():void {
        this.errorMessages = DEFAULT_ERROR_MESSAGES;

        this.loading = false;

        this.actionsAllowed = [];
        this.actionsSelected = [];

        this.rol = new Rol();
        this.permissionSelected = new RolPermission();
    }

    public ngOnInit() {
        this.createFormGroup();

        this.sub = this.route.params.subscribe(params => {
            let rolId = params['rolId'];
            if (rolId) {
                this.rolId = rolId;
                this.createMode = false;
            } else {
                this.rolId = null;
                this.createMode = true;
            }
            this.getData();
        });
    }

    public ngOnDestroy() {
        this.sub.unsubscribe();
    }

    private createFormGroup():void {
        let group:any = {};
        group['name'] = new FormControl(null, Validators.required);
        group['description'] = new FormControl(null);
        group['admin'] = new FormControl(null);
        group['permission'] = new FormControl(null);
        group['permissionSelectedVisible'] = new FormControl(null);
        group['actions'] = new FormControl(null);
        this.form = new FormGroup(group);
    }

    private getData():void {
        this.loading = true;

        let forkTasks:Observable<any>[] = [];
        if (this.rolId) {
            forkTasks.push(this.rolesService.getRol(this.rolId));
        } else {
            forkTasks.push(this.rolesService.getNewRol());
        }
        Observable.forkJoin(forkTasks).subscribe(
            this.setData.bind(this),
            () => {
                this.bindError('Ocurrió un error al obtener los datos del rol.');
            });
    }

    private setData(data:any[]):void {
        this.loading = false;

        this.rol = new Rol(data[data.length - 1]);
        if (this.rol.permissions.length > 0) {
            this.permissionSelectedId = this.rol.permissions[0].appSection.id;
            this.permissionSelected = this.rol.permissions[0];
            this.setActionsSelected();
            this.getActionsAllowed();
        }
    }

    public save():void {
        this.clearMessages();
        this.loading = true;

        this.rolesService.save(this.rol).subscribe(
            (saved:Rol) => {
                this.loading = false;
                this.rol = saved;
                this.successMessage = 'El rol se guardó con éxito';
            },
            () => {
                this.bindError('Ocurrió un error al guardar los datos del rol.');
            });
    }

    private clearMessages():void {
        this.successMessage = null;
        this.errorMessage = null;
    }

    public goBack(event:any):void {
        event.preventDefault();
        this.close.emit(this.rol);
        window.history.back();
    }

    public permissionChange(id:string):void {
        let result = this.rol.permissions.filter(function (obj:RolPermission) {
            return obj.appSection.id == id;
        });
        if (result.length > 0) {
            this.permissionSelected = result[0];
            this.setActionsSelected();
            this.getActionsAllowed();
        }
    }

    private setActionsSelected():void {
        this.actionsSelected = this.permissionSelected.actions.map((action)=>action.id);
    }

    private getActionsAllowed():void {
        this.loading = true;
        this.actionsAllowed = [];
        if (this.permissionSelected) {
            this.rolesService.getActionsAllowed(this.permissionSelected.appSection.id).subscribe(
                (actions) => {
                    this.loading = false;
                    this.actionsAllowed = actions;
                },
                () => {
                    this.bindError('Ocurrió un error al buscar las acciones de permitidas.');
                });
        }
    }

    public updateActionsSelected(target:any):void {
        this.permissionSelected.actions = Array.apply(null, this.actionsSelected)  // convert to real Array
            .map((value:string) => this.actionsAllowed.filter(
                (action)=> {
                    return action.id == value
                })[0]);
    }

    private bindError(messageError:string):void {
        this.loading = false;
        if (this.errorMessage == null) {
            this.errorMessage = messageError;
        } else {
            this.errorMessage = this.errorMessage.toString() + ' ' + messageError;
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/config/roles/rol.editor.component.ts
 **/